<template lang="pug">
  v-app(style="background: #F2F6F7")
    Toolbar
    v-content
      loading
      router-view
    ErrorMessage
    SuccessMessage

    v-footer(height="60" style="background-color: #2C3A47")
      //div
        v-img(src="../public/semsenha-2019-bk.svg" aspect-ratio="4" width="136" contain)
      v-spacer
      div
        span(class="body-2 primary--text") {{ $t('footer.NEEDSHELP') }}
        br
        span(class="caption font-weight-medium white--text myFont") suporte@semsenha.com
</template>

<script>
//import { mapGetters } from 'vuex'

import Toolbar from './components/core/Toolbar'
import Loading from '@/components/core/Loading.vue'

export default {
  name: 'App',
  components: {
    Toolbar,
    Loading
  }
}
</script>

<style>

  app{
    display: none;
  }

<style>
